import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/layout-stability.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// StrictMode is temporarily disabled for development to prevent double-mounting
// during the resolution of existing infinite loop issues.
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Performance optimization: Stagewise toolbar removed to eliminate layout shifts
// Previous CLS impact: 0.283 (63% of total layout shift issues)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Cache bust: 1755563275
